import React, {useState} from "react";
import classNames from "classnames";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import logo from "../assets/Braun_Logo.png";
import {AmplifyAuthAlert, AmplifyAuthError} from "./AmplifyAuthAlert";
import Auth, {CognitoUser} from "@aws-amplify/auth";
import {useNavigate} from "react-router-dom";
import {Alert} from "react-bootstrap";
import {ModalShowMessage} from "../admin/ModalShowMessage";
import {PasswordRequirements} from "./PasswordRequirements";
import {passwordExpression} from "../util"

export interface ChangePasswordProps {
    cognitoUser: CognitoUser | undefined,
    cognitoUserChanged: (newUser: CognitoUser | undefined) => void
}
export const ChangePassword: React.FC<ChangePasswordProps> = (props: ChangePasswordProps) => {
    const navigate = useNavigate();
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPwValid, setNewPwValid] = useState(true);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPwValid, setConfirmPwValid] = useState(true);
    const [authError, setAuthError] = useState<AmplifyAuthError>()
    const passwordChangedMsg:string = "Password changed!";

    const updateNewPw = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setNewPassword(event.target.value)
        setNewPwValid(event.target.value.length === 0 || passwordExpression.test(event.target.value))
    }

    const updateConfirmPw = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setConfirmPassword(event.target.value)
        setConfirmPwValid(event.target.value.length === 0 || passwordExpression.test(event.target.value))
    }

    const handleSubmit = (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();

        // We need to run regex tests here because passwords are checked only if the user edits the fields.
        if (currentPassword === "") {
            displayAlert("Current password must be specified");
        }
        else if (confirmPassword !== newPassword) {
            displayAlert("New and confirm passwords don't match");
        }
        else if (passwordExpression.test(newPassword) === false) {
            displayAlert("New or confirm password is invalid");
        }
        else {
            Auth.changePassword(props.cognitoUser, currentPassword, newPassword)
            .then((result: string) => {
                // We don't need to tell the parent app the Cognito user has changed.
                // props.cognitoUserChanged(props.cognitoUser);
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("");
                return result;
            })
            .then((result: string) => {
                displayAlert(passwordChangedMsg);
            })
            .catch((err: AmplifyAuthError) => {
                setAuthError(err)
            })
        }
    };

    ///////////////////////////////////
    // For the alert message
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    function displayAlert(message:string) {
        setAlertMessage(message);
        setShowAlert(true);
    }

    const handleCloseAlert = () => {
        setShowAlert(false);

        // If this is the password changed message, we successfully
        // changed the password, so go to the Home page.
        // We do this to delay navigating until the alert dialog is closed.
        if (alertMessage === passwordChangedMsg)
            navigate("/");
    }

    return (
        <div>
            {
            props.cognitoUser === undefined &&
            <div className={classNames("d-flex justify-content-center align-items-center")}>
                <Form className={classNames("rounded p-4 p-sm-3 rit-form")}>
                    <div className={classNames("text-center")}>
                        <img className="mb-3" alt="Braun Logo" width="141" height="58" src={logo}/>
                        <Alert variant={"warning"}>
                            No user is logged in.<br/>Log in first then change the password.<br/>
                        </Alert>
                    </div>
                </Form>
            </div>
            }

            {
            props.cognitoUser !== undefined &&
            <div className={classNames("d-flex justify-content-center align-items-center")}>
                <Form className={classNames("rounded p-4 p-sm-3 rit-form")} onSubmit={handleSubmit}>
                    <div className={classNames("text-center")}>
                        <img className="mb-3" alt="Braun Logo" width="141" height="58" src={logo}/>
                    </div>
                    <div className={classNames("text-center")}>
                        <Form.Label><strong>Change Password</strong></Form.Label>
                    </div>
                    <Form.Group className={classNames("mb-3")} controlId="current_pw">
                        <Form.Label>Current Password</Form.Label>
                        <Form.Control type="password" value={currentPassword} onChange={event => setCurrentPassword(event.target.value)}/>
                    </Form.Group>
                    <Form.Group className={classNames("mb-3")} controlId="new_pw">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control type="password" value={newPassword} isInvalid={!newPwValid} onChange={event => updateNewPw(event)}/>
                    </Form.Group>

                    <Form.Group className={classNames("mb-3")} controlId="confirm_pw">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control type="password" value={confirmPassword} isInvalid={!confirmPwValid} onChange={event => updateConfirmPw(event)}/>
                    </Form.Group>
                    <div className={classNames("text-center", "mb-3")}>
                        <Button variant="primary" type="submit">Submit</Button>
                    </div>
                    <PasswordRequirements/>
                </Form>
            </div>
            }

            {/* Modal to show auth message. */}
            <AmplifyAuthAlert error={authError}/>

            {/* Modal to show message. */}
            <ModalShowMessage show={showAlert}
                message={alertMessage}
                variant="danger"
                handleClose={handleCloseAlert}
            />
        </div>
    );
}
    